import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/use-auth';
import { LandingNavbar } from '../components/landing-navbar';
import { HeroSection } from '../components/hero-section';
import { PainPointsSection } from '../components/pain-points-section';
import { IndustryStripSection } from '../components/industry-strip-section';
import { ProductShowcaseSection } from '../components/product-showcase-section';
import { DynamicPricingSection } from '../components/dynamic-pricing-section';
import { ImportsSection } from '../components/imports-section';
import { ControlSection } from '../components/control-section';
import { StatsSection } from '../components/stats-section';
import { PricingSection } from '../components/pricing-section';
import { FaqSection as LandingFaqSection } from '../components/faq-section';
import { VideoSection } from '../components/video-section';
import { CtaFooterSection } from '../components/cta-footer-section';
import { BookDemoModal } from '../components/book-demo-modal';
import { RoiCalculatorSection } from '../components/roi-calculator-section';

export function LandingPage() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Scroll to hash section when navigating from another page
  useEffect(() => {
    if (location.hash) {
      // Small delay to let the DOM render
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        el?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location.hash]);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen text-gray-900 dark:text-gray-100 overflow-x-hidden bg-gradient-to-br from-white via-blue-50/40 to-violet-50/30 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
      {/* Animated gradient mesh */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-0 -left-40 w-[600px] h-[600px] bg-blue-500/20 dark:bg-blue-500/10 rounded-full blur-[128px] animate-float" />
        <div
          className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-violet-500/20 dark:bg-violet-500/10 rounded-full blur-[128px] animate-float"
          style={{ animationDelay: '2s' }}
        />
        <div
          className="absolute bottom-0 left-1/3 w-[400px] h-[400px] bg-cyan-500/15 dark:bg-cyan-500/5 rounded-full blur-[128px] animate-float"
          style={{ animationDelay: '4s' }}
        />
      </div>

      {/* Page-wide dot grid */}
      <div
        className="fixed inset-0 pointer-events-none z-0"
        style={{
          backgroundImage: 'radial-gradient(circle, #94a3b8 1px, transparent 1px)',
          backgroundSize: '32px 32px',
          opacity: 0.15,
          maskImage: 'radial-gradient(ellipse 100% 100% at 50% 0%, black 50%, transparent 100%)',
          WebkitMaskImage:
            'radial-gradient(ellipse 100% 100% at 50% 0%, black 50%, transparent 100%)',
        }}
      />
      <LandingNavbar />
      <HeroSection />
      <VideoSection />
      <PainPointsSection />
      <IndustryStripSection />
      <ProductShowcaseSection />
      <DynamicPricingSection />
      <ImportsSection />
      <ControlSection />
      <StatsSection />
      <RoiCalculatorSection />
      <PricingSection />
      <LandingFaqSection />
      <CtaFooterSection />
      <BookDemoModal />
    </div>
  );
}
